import { useApiData } from "./useApiData"

export interface AccountUser {
  id: number
  isAnonymous: boolean
  isGuest: boolean
  uuid: string
}

const useAccountUser = () => {
  const { data: accountUser, error } = useApiData<AccountUser>(`accounts/user/`)
  return { accountUser, error }
}

export default useAccountUser
